import { render, staticRenderFns } from "./videoMarkTag.vue?vue&type=template&id=3ba59d6e&scoped=true&"
import script from "./videoMarkTag.vue?vue&type=script&lang=js&"
export * from "./videoMarkTag.vue?vue&type=script&lang=js&"
import style0 from "./videoMarkTag.vue?vue&type=style&index=0&id=3ba59d6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba59d6e",
  null
  
)

component.options.__file = "videoMarkTag.vue"
export default component.exports